// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/azurebackup/views/dashboard/components/eventsWidget/eventsWidget.style.scss
// module id = 490
// module chunks = 0